import { createSlice } from "@reduxjs/toolkit";
import { DocumentHeaderResponseDto } from "../../shared/dtos/document/DocumentHeaderResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const documentHeaderSlice = createSlice({
  name: "documentHeader",
  initialState: getInitialCrudState<DocumentHeaderResponseDto>(),
  reducers: {
    ...generateCrudReducers<DocumentHeaderResponseDto>(),
  },
});

export const documentHeaderActions = documentHeaderSlice.actions;
export default documentHeaderSlice.reducer;
